var map = {
	"./krathong": "8dc7",
	"./krathong.vue": "8dc7",
	"./loy": "9a4b",
	"./loy.vue": "9a4b",
	"./loykathong": "d606",
	"./loykathong.vue": "d606",
	"./test_loy": "1b55",
	"./test_loy.vue": "1b55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed1c";